<template>
  <div style="height: 76px !important;">
    <div class="expand-item-container" style="margin-left: 35px; position: absolute;">
        <div class="expand-item">
          单据状态：<span>{{row.status}}</span>
        </div>
        <div class="expand-item" v-if="!isEquipment">
          商品类型：<span>{{row.inventoryInfoGoodsTypeName}}</span>
        </div>
        <div class="expand-item">
          采购来源：{{row.inventoryInfoPurchaseTypeName}}
        </div>
        <div class="expand-item" v-if="!isEquipment">
          是否DTP：{{row.goodsInfoVoIsDtp}}
        </div>
        <div class="expand-item" v-if="!isEquipment">
           是否处方药：{{row.goodsInfoVoIsPrescriptionDrug}}
        </div>
        <div class="expand-item" v-if="showMH">
          是否含麻黄碱：{{row.goodsInfoVoIsEphedrineDrugs}}
        </div>
        <div class="expand-item">
          {{(showRatify ? '批准文号' : '注册证号/备案号') + '：' + row.goodsInfoVoApprovalCode}}
        </div>
        <div class="expand-item">
          产地：{{row.goodsInfoVoCountryOfOrigin}}
        </div>
      </div>
      <div class="expand-item-container" style="margin-left: 35px; margin-top: 25px; position: absolute;">
        <div class="expand-item" v-if="!isEquipment">
          剂型：{{row.goodsInfoVoDosageFormName}}
        </div>
        <div class="expand-item">
          供应商：{{row.inventoryInfoSupplierName}}
        </div>
        <div class="expand-item" v-if="!isEquipment">
          药品上市许可持有人：{{row.goodsInfoVoMah}}
        </div>
        <div class="expand-item">
          储存条件：{{row.goodsInfoVoStorageConditionName}}
        </div>
      </div>
      <div class="expand-item-container" style="margin-left: 35px;margin-top: 50px; position: absolute;">
        <div class="expand-item">
          GSP分类：{{row.goodsInfoVoGsps}}
        </div>
        <div class="expand-item">
          仓库：{{row.inventoryInfoWarehouseName}}
        </div>
        <div class="expand-item">
          货位：{{row.inventoryInfoLocationCode}}
        </div>
        <div class="expand-item" v-if="!isEquipment">
          产品追溯码：{{row.traceCode}}
        </div>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';

export default {
  name: 'InventoryInfoExpand',
  props: {
    row: {
      type: Object,
      default() {
        return {};
      },
    },
    isEquipment: {
      type: Boolean,
      default() {
        return false;
      },
    },
    showRatify: {
      type: Boolean,
      default() {
        return true;
      },
    },
    isEphedrine: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    ...mapGetters([
      'getGoodsOrigin',
      'getNormalGoodsTypes',
    ]),
    fromStr() {
      let purchaseTypeName = '';
      this.getGoodsOrigin.forEach((item) => {
        if (item.value === this.row.purchaseType) {
          purchaseTypeName = item.name;
        }
      });
      return purchaseTypeName;
    },
    showMH() {
      return !this.isEquipment && !this.isEphedrine;
    },
  },
};
</script>
<style  lang="less" scoped>
  .text500 {
    font-weight: 500;
  }
</style>
